import { storyMessagesToConversation, type AccountStoryDocument } from "@private-fiction/story-core";
import type { DemoBot } from "./demo";

export interface AppBot extends DemoBot { document?: AccountStoryDocument }

const tones = ["forest", "romance", "violet", "signal", "court"];

export function projectAccountBot(document: AccountStoryDocument, index = 0, sessions: readonly AccountStoryDocument[] = []): AppBot {
  const stringValue = (key: string, fallback = "") => typeof document[key] === "string" ? String(document[key]) : fallback;
  return {
    id: document.id,
    title: document.title,
    description: document.botDescription || stringValue("description", "เรื่องส่วนตัวจากสตูดิโอของคุณ"),
    gender: document.botGender || "Story",
    mode: document.botMode === "chat" ? "chat" : "novel",
    tags: document.tags,
    tone: tones[index % tones.length]!,
    accent: stringValue("accent", "#ff6b35"),
    playCount: Number(document.playCount ?? 0),
    likeCount: Number(document.likeCount ?? 0),
    characterCreationEnabled: document.characterCreationEnabled,
    hasPlayableSession: sessions.some((session) => session.sourceBotId === document.id),
    intro: stringValue("openingScene", document.introCard || "เรื่องนี้ยังไม่มีฉากเปิด ครีเอเตอร์สามารถเพิ่มได้ในสตูดิโอ"),
    document,
  };
}

export function sessionMessages(document: AccountStoryDocument) {
  return storyMessagesToConversation(document.messages, document.id);
}
